// extracted by mini-css-extract-plugin
module.exports = {"person":"styles_person__3tGE9","personPhoto":"styles_personPhoto__IUGY6","date":"styles_date__RJn_R","button":"styles_button__3fm6u","watch":"styles_watch__1lbjh"};